import idFilters from "state/idFilters";
import yesNoFilters from "state/yesNoFilters";

const keyToFilter = key => {
  const [type, ...rest] = key.split("-");
  const value = rest.join("-");

  if (yesNoFilters.includes(type)) {
    return {
      type,
      value: value === "yes",
    };
  }

  if (
    idFilters.includes(type) ||
    ["origin", "created", "updated"].includes(type)
  ) {
    return { type, value };
  }

  throw new Error(`Can't convert key into filter: ${key}`);
};

export default keyToFilter;



// WEBPACK FOOTER //
// ./src/components/FilterMenu/keyToFilter.js